import React from 'react';
import { Activity, TrendingUp, Heart, Zap, Target } from 'lucide-react';
import { mockData } from '../../mock';

const ICON_MAP = {
  Activity,
  TrendingUp,
  Heart,
  Zap,
  Target,
};

const FrameworkSection = () => {
  const { framework } = mockData;

  return (
    <section
      id="framework"
      className="section-padding"
      data-testid="framework-section"
    >
      <div className="container">
        <div className="text-center mb-12">
          <h2 className="section-title">{framework.title}</h2>
          <p className="section-subtitle">{framework.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-6">
          {framework.pillars.map((pillar) => {
            const Icon = ICON_MAP[pillar.icon] || Activity;
            return (
              <div
                key={`pillar-${pillar.id}`}
                className="reason-card"
                data-testid={`framework-pillar-${pillar.title.toLowerCase()}`}
                style={{ textAlign: 'center' }}
              >
                <div
                  className="service-icon"
                  style={{ margin: '0 auto 1rem' }}
                  aria-hidden="true"
                >
                  <Icon size={32} />
                </div>
                <h3
                  className="reason-title"
                  style={{ letterSpacing: '0.08em', fontWeight: 800 }}
                >
                  {pillar.title}
                </h3>
                <p
                  style={{
                    fontSize: '0.85rem',
                    textTransform: 'uppercase',
                    letterSpacing: '0.15em',
                    color: 'var(--brand-accent, #FFD700)',
                    marginBottom: '0.75rem',
                    fontWeight: 600,
                  }}
                >
                  {pillar.subtitle}
                </p>
                <p className="reason-description">{pillar.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FrameworkSection;
